import React, { useEffect } from 'react'
import './styles/sharedStyles.css'
import './App.css'
import { RouterProvider } from 'react-router-dom'
import { router } from './router/index.tsx'
import { useDispatch } from 'react-redux'
import { setWindowWidth } from './store/storeSlice.ts'
import ReactGA from 'react-ga4'

// const defaultOptions = {
//   loop: false,
//   autoplay: true,
//   animationData: animationData,
//   rendererSettings: {
//     preserveAspectRatio: 'xMidYMid slice'
//   }
// };

function App () {
	const dispatch = useDispatch()

	// const showBodyAfterLoader = () => {
	//   const bodyContainer = document.querySelector('.body-container')
	//   const loaderContainer = document.querySelector('.main-loader-container')

	//   setTimeout(() => {
	//     loaderContainer.classList.add('opacity-0-ease')
	//     setTimeout(() => {
	//       bodyContainer.classList.add('position-initial')

	//       dispatch(setLoaderShown(true))
	//     }, 500)
	//   }, 2600)
	// }

	useEffect(() => {
		ReactGA.initialize('G-X6BNFGQ2SR')
		// showBodyAfterLoader()

		const handleResize = () => dispatch(setWindowWidth(window.innerWidth))
		handleResize()

		window.addEventListener('resize', handleResize)
		return () => window.removeEventListener('resize', handleResize)
	}, [])

	return (
		<>
			<RouterProvider router={router} />
			{/* {
        !loaderShown &&
        <div className='main-loader-container' >
          <div className='lottie-loader'>
            <Lottie
              options={defaultOptions}
              height={window.innerHeight}
              width={window.innerWidth}
              isClickToPauseDisabled={true}
            />
          </div>
        </div>
      } */}
		</>
	)
}

export default App
